/*
  get all main nav elements
  check which element is active
  get the width of the active element
  create own function to place the lava-line
  the function takes one li element as argument
  the function places the lava-line under the li element
  the function sets the width of the lava-line to the width of the li element
  the function sets the left position of the lava-line to the left position of the li element
  for the left position of the lava-line the css property scaleX is used
  in css the width property needs a transition to animate the lava-line
  the transition is set to ease-in-out .3s
  the function is called on hover of the main nav elements
 */
export default function initLavaBar() {
  const mainNavElements = document.querySelectorAll('.main-nav .nav-item');
  const mainNavDropdownElements = document.querySelectorAll('.main-nav .dropdown-toggle');
  // map all dropdown elements to bootstrap dropdown
  const dropdownList = [...mainNavDropdownElements].map(mainNavDropdownElements => new bootstrap.Dropdown(mainNavDropdownElements))
  const homeLink = document.querySelector('.main-nav .home');
  const lavaLine = document.querySelector('.main-nav .lava-line');
  const activeElement = document.querySelector('.main-nav .active');

  setLavaLineToElement(activeElement?.parentElement);

  mainNavElements.forEach((element) => {
    // If bootstrap 5 media-breakpoint-up(lg) on hover activate dropdown
    if (window.matchMedia('(min-width: 992px)').matches) {
      // on hover of homeLink hide all dropdowns
      homeLink.addEventListener('mouseenter', () => {
        hideAllDropdowns(dropdownList);
        setLavaLineToElement(homeLink);
      });

      dropdownList.forEach((dropdown) => {
        dropdown._element.addEventListener('mouseenter', () => {
          // hide all other dropdowns which are not current hovered dropdown
          hideDropdownsNotEqualToCurrent(dropdownList, dropdown);
          // show current hovered dropdown
          dropdown.show();
        });
        // on dropdown click open link in same window
        dropdown._element.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = dropdown._element.href;
        });
      });

      element.addEventListener('show.bs.dropdown', () => {
        setLavaLineToElement(element);
      });

      element.addEventListener('hide.bs.dropdown', () => {
        if (element.querySelector('.active')) {
          setLavaLineToElement(element);
        }
      });

      element.addEventListener('mouseleave', () => {
        hideAllDropdowns(dropdownList);
        setLavaLineToElement(activeElement.parentElement);
      });
    }
  });

  function setLavaLineToElement(element) {
    lavaLine.style.transform = `scaleX(1)`;
    lavaLine.style.width = `${element.offsetWidth}px`;
    lavaLine.style.left = `${element.offsetLeft}px`;
  }

  function hideDropdownsNotEqualToCurrent(array, currentElement) {
    let otherElements = array.filter(element => element !== currentElement);
    otherElements.forEach(element => element.hide());
  }

  function hideAllDropdowns(array) {
    array.forEach(element => element.hide());
  }
};
